import { Controller } from "@hotwired/stimulus"

// Schickt das Formular ab, sobald sich eine Auswahl ändert (z. B. die
// Jahresauswahl). Ersetzt vacation_days.js.erb, sick_days.js.erb und
// data-submit-on-change. requestSubmit löst submit-Ereignisse aus, damit
// Turbo das Absenden übernimmt. Ohne JS bleibt der <noscript>-Button.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
